import React from 'react';
import {
    Grid,
    TextField,
    Autocomplete
} from '@mui/material';

interface CodeServiceMappingStepProps {
    values: any;
    codeServicesFromClient: any[];
    handleTargetCodeServiceChange: (setFieldValue: any, index: number, obj: any) => void;
    handleNewCodeServicceeChange: (setFieldValue: any, index: number, val: string) => void;
    touched: any;
    errors: any;
    getCodeServiceHelperText: (touched: any, key: string, index: number) => any;
    getCodeServiceError: (errors: any, key: string, index: number) => any;
    setFieldValue: (field: string, value: any) => void;
    handleBlur: (e: any) => void;
    classes: any;
}

const CodeServiceMappingStep: React.FC<CodeServiceMappingStepProps> = ({
    values,
    codeServicesFromClient,
    handleTargetCodeServiceChange,
    handleNewCodeServicceeChange,
    touched,
    errors,
    getCodeServiceHelperText,
    getCodeServiceError,
    setFieldValue,
    handleBlur,
    classes
}) => {
    return (
        <>
            {values.codeServiceMapping.map((rule, index) => (
                <Grid container className='pb-4 align-items-start' key={index} sx={{ borderBottom: '1px solid #f0f0f0', pt: 2, px: 1 }}>
                    <Grid item xs={4} className='pr-3'>
                        <Grid className={classes.w90}>
                            <div><b>{rule.ruleName}</b></div>
                            <div><span className='font-12'><i>Code Service</i>: {rule.codeServiceName}</span> </div>
                        </Grid>
                    </Grid>
                    <Grid item xs={4}>
                        <Autocomplete
                            onChange={(e, value) => handleTargetCodeServiceChange(setFieldValue, index, value)}
                            className={classes.w90}
                            value={rule.targetCodeServiceId}
                            options={[{ id: 0, name: 'Copy Code Service' }, ...codeServicesFromClient]}
                            getOptionLabel={(option) => option.name || ''}
                            isOptionEqualToValue={(option, value) => value.name === option.name}
                            renderInput={params => (
                                <TextField {...params} label="Target Code Service *" fullWidth />
                            )}
                            disableClearable
                        />
                    </Grid>
                    <Grid item xs={4}>
                        {rule.targetCodeServiceId.id === 0 && (
                            <TextField
                                required
                                label="New Code Service Name"
                                name={`codeServiceMapping.${index}.newCodeServiceName`}
                                className={classes.w90}
                                value={rule.newCodeServiceName}
                                onBlur={handleBlur}
                                onChange={e => handleNewCodeServicceeChange(setFieldValue, index, e.target.value)}
                                helperText={getCodeServiceHelperText(touched, 'newCodeServiceName', index) && getCodeServiceError(errors, 'newCodeServiceName', index)}
                                error={Boolean(getCodeServiceHelperText(touched, 'newCodeServiceName', index) && getCodeServiceError(errors, 'newCodeServiceName', index))}
                            />
                        )}
                    </Grid>
                </Grid>
            ))}
        </>
    );
};

export default CodeServiceMappingStep;
